import { useEffect, useState } from 'react';
import { parseGameTime, formatTimestamp, getTimeRemaining } from '../../helpers/redeemTimeUtils';
import { formatLamports, formatTokenAmount } from '../../helpers/redeemFormatUtils';
import { getRedeemButtonState } from '../../helpers/redeemButtonStates';
import RedeemActionButtons from './RedeemActionButtons';
import RedeemStatusBadge from './RedeemStatusBadge';
import './RedeemableGamesTable.css';

function RedeemableGamesTable({ games, walletConnected, walletBalances, balancesLoading, onRedeem }) {
  const [currentTime, setCurrentTime] = useState(Date.now());

  // Update time every minute for countdown refresh
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  const handleRedeem = (game) => {
    onRedeem(game);
  };

  if (games.length === 0) {
    return (
      <div className="redeem-table-empty">
        <p>No redeemable games found.</p>
      </div>
    );
  }

  return (
    <div className="redeem-table-container">
      <table className="redeem-table">
        <thead>
          <tr>
            <th>Game ID</th>
            <th>Status</th>
            <th>Mint</th>
            <th>Reserve (SOL)</th>
            <th>Supply</th>
            <th>Redeem End Time</th>
            <th>Time Remaining</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {games.map((game) => {
            const redeemEndTime = parseGameTime(game.redeem_end_time);
            const timeRemaining = getTimeRemaining(redeemEndTime);
            const tokenBalance = walletBalances?.[game.mint] || '0';
            const redeemState = getRedeemButtonState(game, walletConnected, tokenBalance);

            return (
              <tr key={game.game_id}>
                <td className="redeem-table__game-id">#{game.game_id}</td>
                <td>
                  <RedeemStatusBadge 
                    status={game.status_code} 
                    isExpired={timeRemaining.isExpired}
                  />
                </td>
                <td className="redeem-table__mint">
                  {game.mint || 'N/A'}
                </td>
                <td className="redeem-table__reserve">
                  {formatLamports(game.final_reserve_snapshot_lamports)} SOL
                </td>
                <td className="redeem-table__supply">
                  {formatTokenAmount(game.final_supply_snapshot, 9)}
                </td>
                <td className="redeem-table__timestamp">
                  {formatTimestamp(redeemEndTime)}
                </td>
                <td
                  className={`redeem-table__time-remaining ${
                    timeRemaining.isExpired ? 'redeem-table__time-remaining--expired' : ''
                  }`}
                >
                  {timeRemaining.display}
                </td>
                <td>
                  <RedeemActionButtons
                    redeemState={redeemState}
                    onRedeem={() => handleRedeem(game)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default RedeemableGamesTable;
